import { makeAuthorizedRequest } from '../../../libs/backend-request';

/**
 * SettingsData
 * @typedef {{
 *      gaPixelId: string,
 *      fbPixelId: string,
 *      timezone: string,
 * }} SettingsData
 */

class SettingsDataLoaderReal {
    /**
     * @param {HhConfig} config
     */
    constructor(config) {
        this.config = config;
    }

    /**
     * @param {string} merchantCode
     * @returns {Promise<SettingsData>}
     * @throws
     */
    async loadData(merchantCode) {
        const body = {
            merchantCode,
        };

        const response = await makeAuthorizedRequest({
            path: '/settings_list',
            method: 'POST',
            body,
        });

        if (response.error) {
            throw new Error(response.message);
        }
        if (!Array.isArray(response.data)) {
            this.config.debug.enabled && console.log('response=', response);
            throw new Error('Invalid response');
        }

        const data = response.data.reduce((acc, item) => {
            acc[item.key] = item.value;
            return acc;
        }, {});

        return data;
    }
}

export default SettingsDataLoaderReal;
